module.exports = __webpack_public_path__ + "img/pay-item-2.35a9a098.png";